import { createApi } from "@reduxjs/toolkit/dist/query/react";
// import { defautBaseQuery } from "../../utils/API/fetchBaseQuery";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";

const jobTitleAPI = createApi({
    reducerPath: "jobTitleAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        //** List API */
        getTechnology: builder.mutation({
            query: (userQuery) => ({
                url: '/Job/GetJobList',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Add  API */ 
        add: builder.mutation({
            query: (Details) => ({
                url: '/Job/AddJob',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** GetById API */
        getById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Job/GetJobById/?id=${Number(id)}`),
                method: 'GET',
            }),
            providesTags: ['JobTitle'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getPositionById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Job/GetJobById/?id=${Number(id)}`),
                method: 'GET',
            }),
            providesTags: ['JobTitle'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  Update API */
        update: builder.mutation({
            query: (Details) => ({
                url: '/Job/UpdateJob',
                method: 'POST',
                body: transformRequest(Details)
            }),
            invalidatesTags: ['JobTitle'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Delete API */
        delete: builder.mutation({
            query: (id) => ({
                url: `/Job/DeleteJob/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteJobSkill: builder.mutation({
            query: (positionAppliedSkillId) => ({
                url: `/Job/DeleteJobSkill/?positionAppliedSkillId=${positionAppliedSkillId}`,
                method: 'DELETE',
                body: transformRequest(positionAppliedSkillId)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
})

export const {
    useGetTechnologyMutation, useAddMutation,
    useLazyGetByIdQuery, useUpdateMutation,
    useLazyGetPositionByIdQuery, useDeleteMutation,
    useDeleteJobSkillMutation,
} = jobTitleAPI

export default jobTitleAPI;